<template>
  <component
    :is="tag"
    :class="classes"
    :style="styles"
    class="base-body text-body-1"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <!-- Only use v-html for user data -->
    <div
      v-if="text"
      v-text="text"
    />

    <div
      v-else-if="sanitizedHtml"
      v-html="sanitizedHtml"
    />

    <slot v-else />
  </component>
</template>

<script>
  // Mixins
  import Heading from '@/mixins/heading'
  import { sanitizeHtml } from '@/utils/sanitize'

  export default {
    name: 'BaseBody',

    mixins: [Heading],

    inject: ['theme'],

    props: {
      html: String,
      maxWidth: {
        type: [Number, String],
        default: undefined,
      },
      space: {
        type: [Number, String],
        default: 10,
      },
      tag: {
        type: String,
        default: 'p',
      },
      text: String,
    },

    computed: {
      classes () {
        return [
          'grey--text',
          this.theme.isDark ? 'text--lighten-1' : 'text--darken-1',
          `text-${this.heading.align}`,
          `mb-${this.space}`,
        ]
      },
      styles () {
        return {
          maxWidth: `${this.maxWidth}px`,
        }
      },
      sanitizedHtml () {
        return this.html ? sanitizeHtml(this.html) : ''
      },
    },
  }
</script>

<!--
  富文本表格样式修复
  后台编辑器（如 TinyMCE / Quill）生成的 <table> 标签默认无边框，
  这里为 base-body 内的 table 统一添加边框和内边距，确保阅读体验
  注意：不使用 scoped，因为 v-html 注入的 DOM 不带 scoped data attribute
-->
<style lang="sass">
.base-body
  table
    width: 100%
    border-collapse: collapse
    margin: 16px 0

    th,
    td
      border: 1px solid #ddd
      padding: 8px 12px
      text-align: left

    th
      background-color: #f5f5f5
      font-weight: 600

    tr:nth-child(even)
      background-color: #fafafa

  // 富文本中的图片自适应宽度
  img
    max-width: 100%
    height: auto
</style>
